export const roundBalance = (balance: number): string => {
    if (balance >= 0) {
        return (Math.floor(balance * 100) / 100).toFixed(2);
    } else {
        return '0';
    }
};